import { Sparkles } from "lucide-react";

export default function KeywordFixCard({ t, fix, ok }) {
  const miss = t.true_missing || [];
  if (ok && !fix) return null;
  return (
    <div className="card-surface space-y-3" data-testid="keyword-fix-card">
      <div className="flex items-center gap-2"><Sparkles size={16} className="text-blue-300" />
        <div className="font-semibold">Missing keywords the client truly has</div></div>
      {miss.length > 0 ? (
        <>
          <p className="text-sm text-slate-400">These are in the target JDs and in the client's original resume or facts, but not on the resume yet. Click <b className="text-slate-200">Add missing keywords</b> above: the AI works them into existing lines without changing any number, title or date, then re-runs these tests.</p>
          <div className="flex flex-wrap gap-1.5" data-testid="true-missing-list">
            {miss.map((k) => <span key={k.keyword} className="text-xs px-2 py-0.5 rounded border border-blue-500/40 text-blue-200">{k.keyword} · Tier {k.tier}</span>)}
          </div>
        </>
      ) : !ok && (
        <p className="text-sm text-amber-200" data-testid="no-true-missing">Every keyword the client truly has is already on the resume. The remaining gap is skills the client doesn't have, so the score can't honestly go higher; tailoring per JD or building those skills is the way up.</p>
      )}
      {fix && (
        <div className="border-t border-border pt-3 space-y-2" data-testid="keyword-fix-result">
          <div className="text-sm">Last keyword fix: <b>{fix.before}% → {fix.after}%</b> · {fix.changes.length} line(s) changed{fix.skipped?.length ? ` · ${fix.skipped.length} skipped (would change a number)` : ""}</div>
          {fix.changes.map((c, i) => (
            <div key={i} className="text-xs rounded-md border border-border p-2" data-testid={`keyword-fix-change-${i}`}>
              <div className="text-slate-500 line-through">{c.before}</div>
              <div className="text-slate-100 mt-1">{c.after}</div>
              {c.keywords_added?.length > 0 && <div className="text-emerald-300 mt-1">Added: {c.keywords_added.join(", ")}</div>}
            </div>
          ))}
          {fix.skipped?.map((c, i) => (
            <div key={`s${i}`} className="text-xs rounded-md border border-amber-500/40 p-2" data-testid={`keyword-fix-skipped-${i}`}>
              <div className="text-amber-300">Skipped ({c.reason}). Apply by hand in the Draft step if it's correct:</div>
              <div className="text-slate-200 mt-1">{c.after}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
